import {Divider} from "@material-ui/core";
import React from "react";
import {Values} from "@src/Tools/Values";
import {AppInfoContainer, DetailTitle, DetailValue} from "../styles";

interface IProps {
    title: string;
    value: string;
}

export const InternalAppDetailsItem = ({title, value}: IProps) => (
    <AppInfoContainer>
        <DetailTitle>{title}</DetailTitle>

        <Divider/>
        
        <DetailValue>
            {value ? value : `${Values.getLocalizationValue('thereIsNo')} ${title}`}
        </DetailValue>
    </AppInfoContainer>
)